import { API_URLS } from "../../constants/apiUrls";
import { commonFetch } from "../commonFetch";
  
   export const GetAllClassPeriodsMapping = async (schoolID) => {
    return commonFetch(`${API_URLS.GETALL_PERIOD_APIURL}/${schoolID}`, {
      method: "GET",
      requiresAuth: true,
    });
   }

